export enum CheckoutSessionType {
  Checkout = 0,
  BuyerCheckout = 1,
  PaymentLinks = 2,
  Wallet = 3,
}
